import { Component } from '@angular/core';
import { HeaderLatestComponent } from 'src/app/home/landing-root/header-latest/header-latest.component';
import { PeopleflowFooterComponent } from 'src/app/peopleflow-footer/peopleflow-footer.component';

@Component({
  selector: 'app-careers-custom-brand',
imports: [HeaderLatestComponent, PeopleflowFooterComponent],
  templateUrl: './careers-custom-brand.html',
  styleUrl: './careers-custom-brand.scss',
})
export class CareersCustomBrand {

}
